import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

var state = {
    token: null,
    user: {},
    menuExpand: false,  // 左侧菜单是否收起
    showTip: true,      // 初次登录提示
    showTableClickTip: true,     // 点击表格切换详情提示
    dataDictionary:[],
    menuArray: [],
    lang: '',
    licenceHasExpired: false
}

var mutations = {
    set_token(state, token) {
        state.token = token;
    },
    del_token(state) {
        state.token = '';
    },
    set_user(state, user){
        state.user = user;
    },
    set_menuArray(state, menuArray) {
        state.menuArray = menuArray;
    },
    change_menuExpand(state) {
        state.menuExpand = !state.menuExpand;
    },
    close_showTip(state) {
        state.showTip = false;
    },
    set_dictionary(state, dataList) {
      state.dataDictionary = dataList;
    },
    set_lang(state, lang) {
        state.lang = lang;
    },
    set_licenceHasExpired(state, licenceHasExpired) {
        state.licenceHasExpired = licenceHasExpired;
    }
}

const store = new Vuex.Store({
    state,
    mutations:mutations
})

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store.js